import Model from "../../Model";

export interface TRelativeWorkingInCourt {
  applicantId: number;
  relativesName: string;
  relation: string;
  workPlace: string;
  function: string;
}
export interface IRelativeWorkingInCourt extends TRelativeWorkingInCourt {}
const RelativeWorkingInCourt = Model(
  (model: TRelativeWorkingInCourt): IRelativeWorkingInCourt => {
    const _relativeWorkingInCourt: TRelativeWorkingInCourt = Object.assign(
      {},
      model
    );
    return {
      get applicantId() {
        return _relativeWorkingInCourt.applicantId;
      },

      get relativesName() {
        return _relativeWorkingInCourt.relativesName;
      },

      get relation() {
        return _relativeWorkingInCourt.relation;
      },

      get workPlace() {
        return _relativeWorkingInCourt.workPlace;
      },

      get function() {
        return _relativeWorkingInCourt.function;
      }
    };
  }
);
export default RelativeWorkingInCourt;
